const tooltips = {
    mozgasdatum: 'A mozgásdátum megváltoztatásával a hozzáadott cikkek törlésre kerülnek',
  };
  
  export default function getTooltip(name) {
    return tooltips[name];
  }
  